module.exports = __webpack_public_path__ + "static/media/25.4c4cbf5f.jpg";